<template>
  <div>
    <v-data-table v-model="selected"
                  dense
                  :search="search"
                  :loading="loading"
                  :headers="headers"
                  :items="contacts"
                  :items-per-page="100"
                  item-key="id"
                  :sort-by="['updated_at']"
                  :sort-desc="[true]"
                  :footer-props="{'items-per-page-options': [50, 100, 500]}">
      <template v-slot:item.edit="{item: contact}">
        <v-btn @click.prevent="editContact(contact)"
               x-small>
          Edit
        </v-btn>
      </template>
      <template v-slot:item.name="{item: contact}">
        <div class="text-nowrap">
            {{ contact.name }}
        </div>
      </template>
      <template v-slot:item.email="{item: contact}">
          {{ contact.email }}
      </template>
      <template v-slot:item.status="{item: contact}">
        <v-icon v-if="contact.is_active"
                color="success"
                title="Active">
          fal fa-check-circle
        </v-icon>
        <v-icon v-else
                color="error"
                title="Inactive">
          fal fa-exclamation-triangle
        </v-icon>
      </template>
      <template v-slot:item.sync_from_crm="{item: contact}">
        {{ contact.sync_from_crm ? 'Yes' : 'No' }}
      </template>
      <template v-slot:item.crm_object_id="{item: contact}">
        {{ contact.crm_object_id ? 'Yes' : 'No' }}
      </template>
      <template v-slot:item.created_at="{item: contact}">
        <v-tooltip left>
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs"
                 v-on="on"
                 class="text-nowrap">
              {{ contact.created_at | datetime('MMM D, YYYY') }}
            </div>
          </template>
          <div>
            {{ contact.created_at | datetime('MMMM D, YYYY h:mm a') }}
          </div>
        </v-tooltip>
      </template>
      <template v-slot:item.updated_at="{item: contact}">
        <v-tooltip left>
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs"
                 v-on="on"
                 class="text-nowrap">
              {{ contact.updated_at | datetime('MMM D, YYYY') }}
            </div>
          </template>
          <div>
            {{ contact.updated_at | datetime('MMMM D, YYYY h:mm a') }}
          </div>
        </v-tooltip>
      </template>
      <template v-slot:item.actions="{item: contact}">
        <v-btn @click.prevent="editContact(contact)"
               x-small>
          Edit
        </v-btn>
        <!--v-btn @click.prevent="deleteContact(contact)"
               icon
               x-small>
          <v-icon>
            fal fa-fw fa-trash
          </v-icon>
        </v-btn-->
      </template>

    </v-data-table>
    <v-dialog v-if="newDialog"
              v-model="newDialog"
              max-width="800px">
      <v-form ref="newForm"
              @submit.prevent="saveContact">
        <v-card>
          <v-card-title>
            New Contact
          </v-card-title>
          <v-card-text>
            <user-contact-form :form="editForm">
            </user-contact-form>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit"
                   color="primary"
                   @click.prevent="saveContact">
              Create
            </v-btn>
            <v-btn @click.prevent="closeContactForm">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-if="editedContact"
              v-model="editDialog"
              max-width="800px">
      <v-form ref="editForm"
              @submit.prevent="saveContact">
        <v-card>
          <v-card-title>
            Edit Contact
          </v-card-title>
          <v-card-text>
            <user-contact-form :contact="editedContact"
                               :form="editForm">
            </user-contact-form>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit"
                   color="primary"
                   @click.prevent="saveContact">
              Edit
            </v-btn>
            <v-btn @click.prevent="closeContactForm">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import userContactService from '../../../services/userContactService';
import UserContactForm from './UserContactForm';
import formValidation from '../../../plugins/formValidation';
import pluralize from 'pluralize';
import AddContactsToListDialog from '../../mailcoach/components/AddContactsToListDialog';
import HelpDialog from '../../../components/HelpDialog';
import echo from '../../../plugins/echo';
import DOMPurify from 'dompurify';

export default {
  mixins: [formValidation],
  components: {HelpDialog, AddContactsToListDialog, UserContactForm},
  props: {
    contacts: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    }
  },
  data() {
    return {
      addForm: new Form({
        list: null,
      }),
      helpDialog: false,
      search: null,
      selected: [],
      deletedContact: null,
      deleteDialog: false,
      deleteForm: new Form(),
      editedContact: null,
      editDialog: false,
      editForm: new Form(userContactService.initForm()),
      newDialog: false,
      headers: [
        {
          text: '',
          value: 'edit',
          sortable: false,
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Salutation',
          value: 'salutation',
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Company/Account',
          value: 'company_name',
        },
        {
          text: 'Status',
          value: 'status',
        },
        /*{
          text: 'Source',
          value: 'source',
        },
        {
          text: 'CRM Object',
          value: 'crm_object',
        },*/
        {
          text: 'In CRM',
          value: 'crm_object_id',
        },
        {
          text: 'Sync name',
          value: 'sync_from_crm',
        },
        {
          text: 'Added',
          value: 'created_at',
        },
        {
          text: 'Updated',
          value: 'updated_at',
        },
        /*{
          text: 'Actions',
          value: 'actions',
        },*/
      ],
      showAddToListDialog: false,
      syncing: false, // MLD-2598
    }
  },
  computed: {
    ...mapGetters([
      'canCreateContact', // MLD-2598
      'canSyncContacts', // MLD-2598
      'crmLabel', // MLD-2598
      'isMember',
      'team',
      'user',
    ]),
  },
  created() {
    echo.private(this.user.channel) // MLD-2598
      .listen('CRM.UserContactsImported', e => {
        console.log('CRM.UserContactsImported', e);
        this.syncing = false;
        if (e.success) {
          this.$toast.success(DOMPurify.sanitize(e.message));
        } else {
          this.$toast.error(DOMPurify.sanitize(e.message));
        }
        this.$emit('updated');
      })
  },
  methods: {
    async editContact(c) {
      const contact = await userContactService.getContact(c.id);
      this.editedContact = contact;
      this.editForm = new Form(userContactService.initForm(contact));
      if (contact) {
        this.editDialog = true;
      } else {
        this.newDialog = true;
      }
    },
    closeContactForm() {
      this.editedContact = null;
      this.editForm = new Form(userContactService.initForm());
      this.editDialog = false;
      this.newDialog = false;
    },
    saveContact() {
      if (this.editedContact) {
        this.editForm.put(`/api/user-contacts/${this.editedContact.id}`)
          .then(() => {
            this.$emit('updated')
            this.closeContactForm();
          })
      } else {
        this.editForm.post(`/api/user-contacts`)
          .then(() => {
            this.$emit('updated')
            this.closeContactForm();
          })
      }
    },
    closeDeleteForm() {
      this.deletedContact = null;
      this.deleteDialog = false;
    },
    deleteContact(contact) {
      this.deletedContact = contact;
      this.deleteDialog = true;
    },
    deleteContactConfirm() {
      if (!this.deletedContact) {
        this.closeDeleteForm();
        return;
      }
      this.deleteForm.delete(`/api/user-contacts/${this.deletedContact.id}`)
        .then(() => {
          this.$emit('updated');
        })
        .finally(() => {
          this.closeDeleteForm();
        })
    },
    bulkDelete() {
      const num = pluralize('contact', this.selected.length, true);
      if (confirm(`Are you sure you want to delete ${DOMPurify.sanitize(num)}?`)) {
        const form = new Form({
          contact_id: this.selected
        })
        form.post(`/api/user-contacts/delete`)
          .then(() => {
            this.selected = [];
            this.$emit('updated');
          })
      }
    },
    syncFromCRM() { // MLD-2598
      if (this.syncing) {
        return;
      }
      this.syncing = true;
      console.log(`userContactService.syncFromCRM() START`);
      userContactService.syncFromCRM(this.user.id)
        .then(() => {
          console.log(`userContactService.syncFromCRM() END`);
        })
        .catch(() => {
          this.syncing = false;
        });
    }
  }
}
</script>
